module.exports = __webpack_public_path__ + "img/pumpkin-pancakes.a5cd8667.jpg";